'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

BTHNCounter = function (_Component) {_inherits(BTHNCounter, _Component);function BTHNCounter() {var _temp, _this, _ret;_classCallCheck(this, BTHNCounter);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.











    addScript = function () {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://bringthemhomenow.net/1.1.0/hostages-ticker.js';
      script.setAttribute(
      'integrity',
      'sha384-DHuakkmS4DXvIW79Ttuqjvl95NepBRwfVGx6bmqBJVVwqsosq8hROrydHItKdsne');

      script.setAttribute('crossorigin', 'anonymous');
      document.getElementsByTagName('head')[0].appendChild(script);
    }, _this.

    removeScript = function () {
      var scripts = document.querySelectorAll('script[src="https://bringthemhomenow.net/1.1.0/hostages-ticker.js"]');
      scripts.forEach(function (script) {return script.parentNode.removeChild(script);});
    }, _temp), _possibleConstructorReturn(_this, _ret);}BTHNCounter.prototype.componentDidMount = function componentDidMount() {this.addScript();};BTHNCounter.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {if (prevProps.lang !== this.props.lang) {this.removeScript();this.addScript();}};BTHNCounter.prototype.

  render = function render() {
    return (
      _react2.default.createElement('div', null,
        _react2.default.createElement('div', { id: 'bthn', lang: this.props.lang })));


  };return BTHNCounter;}(_react.Component);


BTHNCounter.propTypes = {
  lang: _propTypes2.default.string };exports.default =


BTHNCounter;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/BTHNCounter/BTHNCounter.js
// module id = 2629
// module chunks = 0